/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2020-04-15 19:46:00
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-03-09 14:55:36
 */
// import { createStore,compose,applyMiddleware } from 'redux';
// import reducer from './reducer';
// import thunk from 'redux-thunk';

// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// const enhancer = composeEnhancers(
//     applyMiddleware(thunk)
// )
// const store = createStore( reducer, enhancer );

// export default store;
import {createStore, compose, applyMiddleware} from 'redux';
import userReducer from './reducer/userReducer';
import MessageReducer from './reducer/messageReducer'
import thunk from 'redux-thunk';//允许 我们 dispatch一个函数  而不是单纯的对象
import {combineReducers} from 'redux'
import cacheReducer from './reducer/cacheReducer';
import resetPwdReducer from './reducer/resetPwdReducer'
import sensingReducer from './reducer/sensingReducer'
import flowReducer from './reducer/flowReducer';
import pageCacheReducer from "./reducer/pageCacheReducer";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const enhancer = composeEnhancers(
    applyMiddleware(thunk)
)
const reducer = combineReducers({
    userReducer: userReducer,
    messageReducer: MessageReducer,
    cacheReducer: cacheReducer,
    resetPwdReducer: resetPwdReducer,
    sensingReducer: sensingReducer,
    flowReducer: flowReducer,
    PageCacheReducer: pageCacheReducer,
})

const store = createStore(reducer, enhancer);


export default store;